import { NavLink } from "react-router-dom";

const TopMenu = () => {


  return (
<nav className="navbar navbar-expand-lg navbar-dark bg-primary py-0 ">

      <div className="container-fluid">
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav">
            <li className="nav-item">
              <NavLink className="nav-link " to="/client/work-orders-active">Home</NavLink>
            </li>
           
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="workOrderDropDown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          Work Order
          </a>
          <ul className="dropdown-menu" aria-labelledby="workOrderDropDown">
            <li>
             <NavLink className="nav-link " to="/client/work-orders-new">New Work Order</NavLink>
              </li>
            <li>
            <NavLink className="nav-link " to="/client/work-orders-search">Search Work Order</NavLink>
            </li>

          
            <li className="nav-item">
              <NavLink className="nav-link " to="/client/work-orders-active">Active Work Order</NavLink>
            </li>
             <li className="nav-item">
              <NavLink className="nav-link " to="/client/work-orders-records-obtained">Records Obtained Work Order</NavLink>
            </li>
            <li>
            <NavLink className="nav-link " to="/client/work-orders-incomplete">Incomplete Work Order</NavLink>
            </li>
            
            <li>
            <NavLink className="nav-link " to="/client/work-orders-closed">Closed Work Order</NavLink>
            </li>
          </ul>
        </li>


            <li className="nav-item">
              <NavLink className="nav-link " to="/client/patients">Patient</NavLink>
            </li>
          
          
            <li className="nav-item">
              <NavLink className="nav-link " to="/client/case-managers">Case Manager</NavLink>
            </li>
      {/*
              
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="reportDropDown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          Reports
          </a>
          <ul className="dropdown-menu" aria-labelledby="reportDropDown">
            <li>
             <NavLink className="nav-link " to="/client/report-turnaround">Avg Turnaround</NavLink>
              </li>
            <li>
            <NavLink className="nav-link " to="/client/report-work-orders-client">Work Order</NavLink>
            </li>
          </ul>
        </li>

 */}   

          </ul>
        </div>
      </div>


    </nav>

  );
};
export default TopMenu;